module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('canvas', {
    attrs: {
      "id": "animatedLogoCanvas",
      "width": "240",
      "height": "240"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5034db93!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnimatedLogo.vue
// module id = 420
// module chunks = 2